/**
 * Client-side upload caps. These MIRROR the backend source of truth in
 * `packages/back/internal/fileutil/limits.go` — keep the two in sync. The
 * backend re-validates every upload authoritatively (size AND image
 * dimensions); this check just gives the user instant feedback and avoids a
 * wasted upload for the common too-big-file case.
 */
const MAX_IMAGE_UPLOAD_BYTES = 20 * 1024 * 1024;
const MAX_FILE_UPLOAD_BYTES = 20 * 1024 * 1024;

/** Per-file size cap (bytes) for the given MIME type. */
function maxUploadBytes(mimeType: string): number {
  return mimeType.toLowerCase().startsWith("image/")
    ? MAX_IMAGE_UPLOAD_BYTES
    : MAX_FILE_UPLOAD_BYTES;
}

/**
 * Returns the cap a file violates (so the caller can show a localized message),
 * or null when the file is within the size limit.
 */
export function uploadSizeViolation(file: File): { maxBytes: number } | null {
  const maxBytes = maxUploadBytes(file.type);
  return file.size > maxBytes ? { maxBytes } : null;
}
